import { useSubscription } from '@/hooks/useSubscription';
import { useAuthStore } from '@/stores/useAuthStore';
import i18n from '@/translations/config';
import { useTranslation } from 'react-i18next';
import { FiZap } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export const UpgradeCallToAction = () => {
  const { user } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hasActiveSubscription } = useSubscription(user ?? null);

  const handleUpgradeToPlusPlan = () => {
    navigate(`/${i18n.language}/dashboard/pricing`);
  };

  if (!user || user.seats.length > 0 || hasActiveSubscription()) {
    return null;
  }

  return (
    <div className="bg-primary shadow-sm">
      <div
        className="group flex cursor-pointer items-center justify-center gap-2 p-3 transition-all duration-300"
        onClick={handleUpgradeToPlusPlan}
      >
        <span className="animate-gradient bg-gradient-to-r from-linko-light via-linko-dark to-linko-light bg-[length:200%_100%] bg-clip-text text-sm font-medium text-transparent">
          {t('sidebar:upgrade-to-plus-plan')}
        </span>
        <FiZap className="size-4 text-linko-light transition-all duration-300 group-hover:scale-110" />
      </div>
    </div>
  );
};
